import { isNumber, parseJsonString } from '@/helpers/common.js';
import { apiRequest } from '@/plugins/api.js';
import { apiResponseTypeEnum } from '@/constants/api.js';
import { appFlowTypeEnum } from '@/constants/appSettings.js';

export const apiRetrieveAppProperties = () => apiRequest({
  url: 'publicapi/getApplicationProperties',
  method: 'GET',
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!responseData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  const inviteConfig = JSON.parse(responseData.inviteConfig);

  return {
    parsedData: {
      appFlowType: Object.values(appFlowTypeEnum).includes(responseData.simpleRegistration) ? responseData.simpleRegistration : '',
      duelSkin: responseData.duelSkin,
      fallingItemsGameCss: responseData.fallingItemsGameCss,
      gamePreModalTime: responseData.swipoTimeForPreGameModals,
      gameRoundTimeList: Array.isArray(responseData.timeRoundList) ? responseData.timeRoundList : [],
      gameTheme: responseData.swipoGameThemes,
      hideChangePassword: Boolean(responseData.hideChangePassword),
      hideLeaderboard: Boolean(responseData.hideLeaderboard),
      hidePoints: Boolean(responseData.hidePoints),
      hidePrizePage: Boolean(responseData.hidePrizePage),
      hidePrizeSectionFromLeaderboard: Boolean(responseData.hidePrizeSectionEnabledAtLeaderBoard),
      hideUserAchievements: Boolean(responseData.hideUserAchievements),
      hideWinners: Boolean(responseData.hideWinners),
      integrationName: responseData.integrationConfig,
      inviteConfig: { inviteEnabled: Boolean(inviteConfig?.inviteEnabled), invitePoints: inviteConfig?.invitePoints ?? 0 },
      isPurchaseBundleFromUnsubUserEnabled: Boolean(responseData.purchaseBundleFromUnsubUser),
      isReoptinOneStep: Boolean(responseData.reoptinOnestep),
      isSingleOptinEnabled: Boolean(responseData.isSingleOptinEnabled),
      isTwoStepFlow: Boolean(responseData.twoStepRegistration),
      maxLengthPinDigits: responseData.maxLengthPinDigits,
      multiOperatorDisplayNames: responseData.multiOperatorDisplayNames,
      multiOperatorDisplayedNamesInRegisterPage: responseData.multiOperatorDisplayedNamesInRegisterPage,
      multiOperatorEnabled: Boolean(responseData.multiOperatorEnabled),
      multiOperatorKeys: responseData.multiOperatorKeys,
      phoneShortcutEnabled: Boolean(responseData.phoneShortcutEnabled),
      puzzleGameCss: responseData.puzzleGameCss,
      showMsisdnInProfilePage: Boolean(responseData.showMsisdnInProfilePage),
      showVatBanner: Boolean(responseData.vatBanner),
      timerForPuzzleGame: isNumber(+responseData.timerForPuzzleGame) ? +responseData.timerForPuzzleGame : null,
      timerForLanternGame: isNumber(+responseData.timerForLanternGame) ? +responseData.timerForLanternGame : null,
      trackingId: responseData.trackingId,
      winnersShowMsisdn: Boolean(responseData.winnersShowMsisdn),
    },
  };
});

export const apiRetrieveMultiOperatorProperties = ({ queryParams }) => apiRequest({
  url: 'publicapi/getMultiOperatorConfigProperties',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!responseData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return {
    parsedData: {
      displayPrice: Boolean(responseData.displayPrice),
      enablePopUpForCrossPromotion: Boolean(responseData.enablePopUpForCrossPromotion),
      hideStore: Boolean(responseData.hideStore),
      isSubAndUnsubViaSMSEnabled: Boolean(responseData.subAndUnsubViaSMS),
      multiOperatorOrdinal: responseData.multiOperatorOrdinal ?? 0,
      pinForBundles: Boolean(responseData.pinForBundles),
      purchaseViaSMS: Boolean(responseData.purchaseViaSMS),
      reoptinAndOptoutConfig: responseData.reoptinAndOptoutConfig || '',
      showOptOutPhase: Boolean(responseData.showOptOutPhase),
      smsAutomaticResponse: Boolean(responseData.smsAutomaticResponse),
    },
  };
});

export const apiRetrieveGtmInfo = () => apiRequest({
  url: 'publicapi/getGTMInfo',
  method: 'GET',
}).then((response) => {
  if (response?.data?.responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: response?.data?.responseEnum });
  }

  return { parsedData: response?.data?.data };
});

export const apiRetrieveVersionInfo = () => apiRequest({
  url: 'publicapi/getVersionInfo',
  method: 'GET',
}).then((response) => {
  const parsedData = parseJsonString(response?.data?.data);

  if (response?.data?.responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: response?.data?.responseEnum });
  } else if (!parsedData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return { parsedData };
});
